export default "__VITE_ASSET__ujVftgeD__"